module.exports = "/hwa/_next/static/images/jarofdirt-7afe2e1c37b519da18331337fc0aa0e1.webp";